// import Swiper JS
import Swiper from "swiper";
import { Navigation, Pagination, EffectFade, Autoplay, Thumbs } from "swiper/modules";

export default class Slider {
  constructor(el) {

    this.el = el;
    this.elms = this.getElms();

    const config = JSON.parse(this.el.dataset.hwcSlider);
    this.swiperConfig = this.getConfig(config);

    const swiper = new Swiper(this.elms.main, this.swiperConfig);

    if (config.startSlide) {
      swiper.slideTo(config.startSlide, false, false);
    }
  }

  getElms() {
    return {
      main: this.el.querySelector('.swiper'),
      wrapper: this.el.querySelector('.swiper-wrapper'),
      next: this.el.querySelector('.swiper-button-next'),
      prev: this.el.querySelector('.swiper-button-prev'),
      pagination: this.el.querySelector('.swiper-pagination'),
    }
  }

  getConfig(config) {

    let swiperConfig = {
      ...config,
      modules: [],
    };

    if (config.navigation) {
      swiperConfig.modules.push(Navigation);
      swiperConfig.navigation = {
        nextEl: this.elms.next,
        prevEl: this.elms.prev,
      }
    }

    if (config.pagination) {
      swiperConfig.modules.push(Pagination);
      swiperConfig.pagination = {
        el: this.elms.pagination,
        clickable: true,
      }
    }

    if (config.fade) {
      swiperConfig.modules.push(EffectFade);
      swiperConfig.effect = "fade";
      swiperConfig.fadeEffect = { crossFade: true };
    }

    if (config.autoplay) {
      swiperConfig.modules.push(Autoplay);
      swiperConfig.autoplay = {
        delay: 5000,
      };
    }

    if (config.center) {
      swiperConfig.centeredSlides = true;
    }

    if (config.space) {
      swiperConfig.spaceBetween = config.space;
    }

    if (!config.slides) {
      swiperConfig.slidesPerView = "auto";
    } else {
      swiperConfig.slidesPerView = config.slides;
    }

    if (config.loop) {
      swiperConfig.loop = true;
    }

    if (config.thumbs) {
      swiperConfig.modules.push(Thumbs);
      const swiperThumbs = document.querySelector(config.thumbs);
      if (swiperThumbs) {
        swiperConfig.thumbs = {
          swiper: swiperThumbs.querySelector(".swiper"),
        };
      }
    }

    return swiperConfig;
  }
}




